import React from 'react'
import { getMappedinKeys } from '../api/requests/Explore'

var keys = null
const useMappedinKeys = () => {
  const [error, setError] = React.useState(null)
  const [loading, setLoading] = React.useState(false)
  const [mappedinKeys, setMappedinKeys] = React.useState(keys)

  const fetchMappedinKeys = async () => {
    setLoading(true)
    setError(null)
    try {
      const { data } = await getMappedinKeys()
      const formattedData = formatData(data)
      keys = formattedData

      setMappedinKeys(formattedData)
      setLoading(false)
      return formattedData
    } catch (error) {
      setError('error')
      setLoading(false)
    }
  }

  const doGetMappedinKeys = async () => {
    if (keys !== null) return keys

    const data = await fetchMappedinKeys()
    return data
  }

  const formatData = data => {
    const { id, secret } = data
    return { clientId: id, clientSecret: secret }
  }

  return {
    error,
    loading,
    mappedinKeys,
    getMappedinKeys: doGetMappedinKeys,
    refreshMappedinKeys: fetchMappedinKeys,
  }
}

export const withMappedinKeys = Component => {
  return function WrappedComponent(props) {
    const { getMappedinKeys } = useMappedinKeys()
    return <Component {...props} getMappedinKeys={getMappedinKeys} />
  }
}

export default useMappedinKeys
